<script setup>
definePage({
  alias: '/pages/misc/not-authorized',
  meta: {
    layout: 'blank',
    public: true,
  },
})

function eraseCookiesAndReload() {
  const cookies = document.cookie.split(';')
  
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()

    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname
  }
  
  window.location.href = window.location.protocol + '//' + window.location.hostname + '/'
}

eraseCookiesAndReload()
</script>

<template>
  <div class="misc-wrapper">
    Logging out...
  </div>
</template>

<style lang="scss">
@use "@core-scss/template/pages/misc.scss";
</style>
